import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import bgImage from "../../assets/bg.jpg";
import logo from "../../assets/logo.svg";
import serverURL from "../../config";

const Registration = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        id_number: "",
        institution: "",
        mobile: "",
        passkey: "",
    });
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);
    const [credentials, setCredentials] = useState(null);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess(false);

        if (
            !formData.name ||
            !formData.email ||
            !formData.id_number ||
            !formData.institution ||
            !formData.mobile ||
            !formData.passkey
        ) {
            setError("Please fill in all required fields.");
            return;
        }

        try {
            const response = await axios.post(
                `${serverURL}/interviews/register`,
                formData
            );
            setSuccess(true);
            setCredentials(response.data.credentials);
        } catch (err) {
            console.error("Registration error:", err);
            setError("Registration failed. Please try again.");
        }
    };

    const handleOk = () => {
        if (success) {
            navigate("/login");
        }
        setCredentials(null);
        setError("");
    };

    return (
        <div className="relative min-h-screen overflow-y-auto">
            <div
                className="fixed inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${bgImage})` }}
            />

            <div className="relative min-h-screen flex items-center justify-center py-8 px-4">
                <div className="bg-white p-6 sm:p-8 rounded-lg shadow-lg w-full max-w-2xl">
                    <div className="flex justify-center mb-6">
                        <img src={logo} alt="vThink Logo" className="h-16 sm:h-20 w-auto" />
                    </div>

                    <h2 className="text-xl font-heading font-semibold mb-6 text-center text-campus-text-primary">User Registration</h2>
                    <p className="text-center text-campus-text-body mb-8">
                        Already have an account?{" "}
                        <a href="/login" className="text-campus-primary hover:text-campus-primary-dark font-medium">
                            Login
                        </a>
                    </p>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="flex flex-col sm:flex-row gap-2">
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Name*"
                                required
                                className="w-full p-3 rounded-lg bg-campus-bg border border-campus-border text-campus-text-primary placeholder-campus-text-body focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition"
                            />
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Email*"
                                required
                                className="w-full p-3 rounded-lg bg-campus-bg border border-campus-border text-campus-text-primary placeholder-campus-text-body focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition"
                            />
                        </div>
                        <div className="flex flex-col sm:flex-row gap-2">
                            <input
                                type="text"
                                id="id_number"
                                name="id_number"
                                value={formData.id_number}
                                onChange={handleChange}
                                placeholder="ID Number*"
                                required
                                className="w-full p-3 rounded-lg bg-campus-bg border border-campus-border text-campus-text-primary placeholder-campus-text-body focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition"
                            />
                            <input
                                type="text"
                                id="institution"
                                name="institution"
                                value={formData.institution}
                                onChange={handleChange}
                                placeholder="Institution*"
                                required
                                className="w-full p-3 rounded-lg bg-campus-bg border border-campus-border text-campus-text-primary placeholder-campus-text-body focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition"
                            />
                        </div>

                        <div className="flex flex-col sm:flex-row gap-2">
                            <input
                                type="text"
                                id="mobile"
                                name="mobile"
                                value={formData.mobile}
                                onChange={handleChange}
                                placeholder="Mobile Number*"
                                required
                                className="w-full p-3 rounded-lg bg-campus-bg border border-campus-border text-campus-text-primary placeholder-campus-text-body focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition"
                            />
                            <input
                                type="password"
                                id="passkey"
                                name="passkey"
                                value={formData.passkey}
                                onChange={handleChange}
                                placeholder="Passkey*"
                                required
                                className="w-full p-3 rounded-lg bg-campus-bg border border-campus-border text-campus-text-primary placeholder-campus-text-body focus:outline-none focus:ring-2 focus:ring-campus-primary focus:border-transparent transition"
                            />
                        </div>

                        {error && <div className="text-red-500 text-sm text-center">{error}</div>}

                        <button
                            type="submit"
                            className="w-full text-white p-3 rounded-lg bg-campus-text-primary hover:bg-campus-text-body transition-colors duration-300 mt-6 font-medium"
                        >
                            REGISTER
                        </button>
                    </form>
                </div>
            </div>

            {(credentials || error) && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full mx-4">
                        {success ? (
                            <>
                                <h3 className="flex items-center justify-center gap-2 text-green-600 text-lg font-medium mb-4">
                                    <FaCheckCircle /> You have Registered Successfully.
                                </h3>
                                <div className="mb-4 text-center">
                                    <p className="mb-2">Email: {credentials?.email}</p>
                                    <p className="mb-2">Password: {credentials?.password}</p>
                                    <p className="text-sm text-gray-600">Please note down this password to login.</p>
                                </div>
                            </>
                        ) : (
                            <h3 className="text-red-600 text-lg font-medium text-center">Registration Failed</h3>
                        )}
                        <button
                            onClick={handleOk}
                            className="w-full bg-campus-primary text-white py-2 px-4 rounded-lg hover:bg-campus-primary-dark focus:outline-none focus:ring-2 focus:ring-campus-primary focus:ring-offset-2 transition-colors font-medium"
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Registration;
